export const contentFrameworks = [
  {
    value: "features-advantages-benefits",
    label: "Features-Advantages-Benefits",
    description:
      "Highlights features, explains advantages, and elaborates on benefits for the customer.",
  },
  {
    value: "pastor",
    label: "PASTOR",
    description:
      "Problem, Amplify, Story, Testimonial, Offer, Response - addresses pain points and presents your solution.",
  },
  {
    value: "before-after-bridge",
    label: "Before-After-Bridge",
    description:
      "Presents current problem, shows improved future state, and bridges how to get there.",
  },
  {
    value: "aida",
    label: "Attention-Interest-Desire-Action",
    description:
      "Grabs attention, builds interest, creates desire, and prompts action.",
  },
  {
    value: "problem-agitate-solve",
    label: "Problem-Agitate-Solve",
    description:
      "Identifies problem, agitates the issue, then presents your solution.",
  },
  {
    value: "star-story-solution",
    label: "Star-Story-Solution",
    description:
      "Introduces a character, tells their story, and shows how your product helps them win.",
  },
  {
    value: "picture-promise-prove-push",
    label: "Picture-Promise-Prove-Push",
    description:
      "Paints a picture, makes promises, provides proof, and pushes for action.",
  },
  {
    value: "acca",
    label: "Awareness-Comprehension-Conviction-Action",
    description:
      "Presents the problem, helps understand it, creates conviction, and prompts action.",
  },
  {
    value: "five-basic-objections",
    label: "5 Basic Objections",
    description:
      "Addresses common objections: time, money, effectiveness, credibility, and necessity.",
  },
  {
    value: "four-cs",
    label: "Four C's",
    description: "Creates clear, concise, compelling, and credible copy.",
  },
  {
    value: "consistent-contrasting",
    label: "Consistent-Contrasting",
    description:
      "Uses consistent messaging with contrasting elements to engage readers.",
  },
  {
    value: "strong-weak",
    label: "Strong-Weak",
    description:
      "Uses strong language for benefits while honestly acknowledging limitations.",
  },
  {
    value: "emotion-logic",
    label: "Emotion-Logic",
    description:
      "Connects emotionally while providing logical arguments for action.",
  },
  {
    value: "personal-universal",
    label: "Personal-Universal",
    description:
      "Makes content personally relevant while connecting to universal experiences.",
  },
  {
    value: "urgency-patience",
    label: "Urgency-Patience",
    description:
      "Creates urgency to act now while highlighting long-term benefits.",
  },
  {
    value: "expectation-surprise",
    label: "Expectation-Surprise",
    description: "Sets expectations then surprises with unexpected benefits.",
  },
  {
    value: "exclusive-inclusive",
    label: "Exclusive-Inclusive",
    description: "Positions product as elite while emphasizing accessibility.",
  },
  {
    value: "positive-negative",
    label: "Positive-Negative",
    description:
      "Focuses on positives while constructively addressing potential negatives.",
  },
  {
    value: "past-present-future",
    label: "Past-Present-Future",
    description:
      "Connects to past experiences, improves present situation, and shapes future positively.",
  },
  {
    value: "friend-expert",
    label: "Friend-Expert",
    description:
      "Uses friendly tone while establishing expertise and credibility.",
  },
  {
    value: "pain-agitate-relief",
    label: "Pain-Agitate-Relief",
    description:
      "Identifies pain points, amplifies consequences, and presents relief.",
  },
  {
    value: "solution-savings-social-proof",
    label: "Solution-Savings-Social Proof",
    description:
      "States problem solution, emphasizes savings, and provides social proof.",
  },
  {
    value: "six-ws",
    label: "6 W's",
    description:
      "Covers who, what, when, where, why, and how for comprehensive messaging.",
  },
  {
    value: "story-solve-sell",
    label: "Story-Solve-Sell",
    description:
      "Tells compelling story, demonstrates solution, and makes strong call to action.",
  },
];
